/**
 * File: activeProject.ts
 * Description: Helpers for broadcasting the chat's active project so it can be
 *   switched from within the chat (e.g. the in-chat project picker) without a
 *   full page navigation. The selection is intentionally not persisted, so the
 *   chat never preselects a previously used project on load.
 * Author: System
 * Created: 2026-06-11
 * Last Modified: 2026-06-11
 */

// Event dispatched on window when the active project changes so listeners
// (e.g. the chat interface) can react without a full page navigation.
export const ACTIVE_PROJECT_EVENT = 'archie:activeProjectChanged';

/**
 * Broadcast an active project change to listeners for the current session.
 */
export const setActiveProjectId = (projectId: number): void => {
  globalThis.dispatchEvent(
    new CustomEvent<number>(ACTIVE_PROJECT_EVENT, { detail: projectId }),
  );
};
